import React, {PureComponent} from 'react';

import {getCurrentUserId, getJwt, getCurrentUserName} from '../../../services/authService';
import http from '../../../services/httpService';
import countries from '../../common/countries';
import usStates from '../../common/usStates';
import {Button, MenuItem} from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import InputRegular from '../../common/InputRegular';
import Header from '../Header'
import {Link} from 'react-router-dom'

import authService from "../../../services/authService";
// import ReactGA from "react-ga";
import axios from "axios";

export default class AccountVerificationSelectType extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <h1>Account Verification</h1>
                <p>
                    To unlock full access to your Emitto account, you should first submit your business or individual details.
                    Customer accounts that have been approved by Emitto will enjoy a high level of trust and access all Emitto
                    features such as messaging services, campaign management, and more. All customer data is processed
                    in <span><strong>72 hours</strong></span> upon form submission.
                </p>
                <p className='margin-top-20 margin-bottom-20'>This is the first step in the <a href='https://emitto.io/know-your-customer-policy' target='_blank'>Emitto Know Your Customer Policy</a>.</p>
                <p className='margin-top-20 margin-bottom-30'>For any questions please contact <a href='mailto:support@emitto.io'>support@emitto.io</a>.</p>
                <h2>Are you a business or an individual? *</h2>
                <div className="tabs-navigation">
                    <div
                        onClick={!this.props.selectedSourceNode.business_verification ? ()=>this.props.handleUpdateSelectedType('Registered business') : ''}
                        className={this.props.selectedType === 'Registered business' ? !this.props.selectedSourceNode.business_verification ?
                            "navigation-tab active " : "navigation-tab active opacity-05" : !this.props.selectedSourceNode.business_verification ?
                            "navigation-tab" : "navigation-tab opacity-05"}>
                        <p>Registered business</p>
                    </div>
                    <div
                        onClick={!this.props.selectedSourceNode.business_verification ? ()=>this.props.handleUpdateSelectedType('Individual') : ''}
                        className={this.props.selectedType === 'Individual' ? !this.props.selectedSourceNode.business_verification ?
                            "navigation-tab active " : "navigation-tab active opacity-05" : !this.props.selectedSourceNode.business_verification ?
                            "navigation-tab" : "navigation-tab opacity-05"}>
                        <p>Individual</p>
                    </div>
                </div>

                <div className='bottom-with-buttons end'>
                    <button onClick={this.props.handleGoToAccountVerificationDetails} className='btn-action'>Next</button>
                </div>
            </div>
        )
    }
}
